<template>
  <div class="app-aside">
    <!-- 导航菜单组件 -->
    <el-menu default-active="2" class="el-menu-vertical-demo">
      <el-submenu :index="indexs + ''" v-for="(itemz, indexs) in bannnerdata" :key="indexs" class="avi">
        <template slot="title">
          <div :class="{
            'online-img6': indexs == 0,
            'online-img': indexs == 1,
            'online-img2': indexs == 2,
            'online-img14': indexs == 3,
            'online-img3': indexs == 4,
            'online-img4': indexs == 5,
            'online-img5': indexs == 6,
            'online-img7': indexs == 7,
            'online-img9': indexs == 8,
            'online-img8': indexs == 9,
            'online-img10': indexs == 10,
            'online-img11': indexs == 11,
            'online-img12': indexs == 12,
            'online-img13': indexs == 13,
          }"></div>
          <span>{{ itemz.parentname }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="indexs + '-' + indexz" v-for="(items, indexz) in itemz.children" :key="indexz"
            @click="tobannav(items)" :class="$route.meta[0] === items.titlename ? 'isrouternav' : ''">{{ items.titlename
            }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "../../../store/index";
export default {
  name: "AppAside",
  props: ["reload"],
  data() {
    return {
      isActiveTitle: [],
      bannnerdata: [
        {
          parentname: "培训任务",
          children: [
            { titlename: "任务管理", name: "Manage" },
            { titlename: "培训情况", name: "Situation" },
          ],
        },
        {
          parentname: "在线考试",
          children: [
            { titlename: "发布试卷", name: "Papers" },
            { titlename: "考试监控", name: "Monitoring" },
            { titlename: "批改试卷", name: "Correcting" },
          ],
        },
        {
          parentname: "在线练习",
          children: [
            { titlename: "发布练习", name: "Testpapers" },
            { titlename: "练习监控", name: "PracticeWatch" },
            { titlename: "每日练习情况", name: "ExerciseState" },
            // { titlename: "数据分析", name: "" },
          ],
        },
        {
          parentname: "临床技能考核",
          children: [
            { titlename: "发布操作考核", name: "ReleaseCheck" },
            { titlename: "操作考核评分", name: "OperationScore" },
            { titlename: "评分表管理", name: "ScoreTable" },
          ],
        },
        // {
        //   parentname: "视频学习任务",
        //   children: [
        //     { titlename: "视频学习任务", name: "VideoTask" },
        //   ],
        // },
        {
          parentname: "纸质试卷",
          children: [
            { titlename: "纸质试卷库", name: "Paperlist" },
            // { titlename: "数据分析", name: "" },
          ],
        },
        {
          parentname: "考生管理",
          children: [
            { titlename: "考生列表", name: "candidateList" },
            { titlename: "考生组列表", name: "ListOfGroups" },
            { titlename: "审核考生列表", name: "ReviewList" },
          ],
        },
        {
          parentname: "科室管理",
          children: [{ titlename: "科室列表", name: "departList" }],
        },

        {
          parentname: "资源管理",
          children: [
            { titlename: "课件管理", name: "Resources" },
            { titlename: "视频管理", name: "Videoresources" },
          ],
        },
        {
          parentname: "题库管理",
          children: [
            // { titlename: "平台题库", name: "Platform" },
            { titlename: "自定义题库", name: "Custom" },
            { titlename: "收藏题库", name: "Collect" },
          ],
        },
        {
          parentname: "公告管理",
          children: [{ titlename: "公告列表", name: "notice" }],
        },

        {
          parentname: "管理员管理",
          children: [{ titlename: "人员管理", name: "Personnel" }],
        },
        {
          parentname: "个人中心",
          children: [
            { titlename: "基础信息", name: "Basis" },
            { titlename: "独立密码", name: "ModifyThe" },
            { titlename: "登录密码", name: "Landingpaw" },
            { titlename: "用户反馈", name: "Feedback" },
            { titlename: "消息通知", name: "Alerts" },
            // { titlename: "开通科目", name: "Subjects" },
          ],
        },
        // {
        //   parentname: "线下培训",
        //   children: [{ titlename: "线下培训", name: "Training" }],
        // },
        {
          parentname: "调查问卷",
          children: [{ titlename: "调查问卷", name: "Answer" }],
        },
      ],
      burietime: [], //埋点记录的时间。['Papers','Tue Dec 28 2021 11:23:30 GMT+0800 (中国标准时间)','Tue Dec 28 2021 11:23:30 GMT+0800 (中国标准时间)']
      buriedarr: [],
    };
  },
  methods: {
    tobannav(itemq) {
      //路由切换功能。
      this.Buriedpoint(itemq);
      if (this.isActiveTitle.indexOf(itemq.titlename) === -1) {
        this.$root.$Navbottom(itemq.titlename, itemq.name);
        this.isActiveTitle.push(itemq.titlename);
      }
      if (this.$route.name != itemq.name) {
        this.$router.push({ name: itemq.name });
      } else {
        this.reload();
      }
    },
    async Buriedpoint(itemt) {
      //二级路由菜单记录
      if (!this.burietime[0]) {
        //当前为空的时候，进行记录第一次时间
        this.burietime[0] = itemt.name;
        this.burietime[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        localStorage.setItem("ismaidian", JSON.stringify(this.burietime));
      } else {
        //不为空的时候，需要判断,路由与当前路由不一致
        if (itemt.name != this.burietime[0]) {
          this.burietime[2] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.burietime[2])).diff(
            new Date(this.burietime[1]),
            "seconds"
          );
          // console.log("在" + this.burietime[0] + "呆了" + statetime);
          //这里进行对比计算。
          let jilu = this.buriedarr.filter((item) => {
            return item.code.indexOf(this.burietime[0]) != -1;
          });
          let jiluCode = []; // 此处存在非空报错，拦截一下
          if (jilu.length == 0) {
            return jiluCode;
          } else if (jilu.length > 0) {
            return (jiluCode = jilu[0].code);
          }
          let parmas = {
            type: "1",
            // code: jilu[0].code,
            code: jiluCode,
            parent_code: jilu[0].parent_code,
            stay_start_time: this.burietime[1],
            stay_end_time: this.burietime[2],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          await systemclass.addburied(parmas);
          //这个地方代表数据记录好了。
          this.burietime[0] = itemt.name;
          this.burietime[1] = this.$moment().format("YYYY/MM/DD HH:mm:ss");
          localStorage.setItem("ismaidian", JSON.stringify(this.burietime));
        }
      }
    },
    Buriedresult() {
      //传入存储。
    },
    Menuquanx() {
      let quanxian = JSON.parse(localStorage.getItem("userlist")).isSuper;
      if (quanxian == 0) {
        this.bannnerdata = this.bannnerdata.filter((item) => {
          return item.parentname !== "管理员管理";
        });
      }
    },
    async getmaidian() {
      if (localStorage.getItem("ismaidian")) {
        this.burietime = JSON.parse(localStorage.getItem("ismaidian"));
        localStorage.removeItem("ismaidian");
      }
      if (!sessionStorage.getItem("listResources")) {
        let parms = {
          source: "khy",
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        let res = await systemclass.getlistResources(parms);
        this.buriedarr = res.data.Data;
        sessionStorage.setItem("listResources", JSON.stringify(res.data.Data));
      } else {
        this.buriedarr = JSON.parse(sessionStorage.getItem("listResources"));
      }
      //   console.log(this.buriedarr);
    },
    getRouterNav() {
      // console.log(this.$router.options.routes[3].children);
      let newbannerdata = this.$router.options.routes[3].children.map(
        (item) => {
          let newobj = {};
          newobj["parentname"] = item.meta[0];
          newobj.children = item.children.map((items) => {
            if (items.name == "SetEncy" || items.name == "DecryTable") {
              return "";
            }
            let newchildrenobj = {};
            newchildrenobj["titlename"] = items.meta[0];
            newchildrenobj["name"] = items.name;
            return newchildrenobj;
          });
          return newobj;
        }
      );
      // console.log(this.$router.options, newbannerdata);
      newbannerdata.forEach((item) => {
        item.children = item.children.filter((items) => {
          return items != "";
        });
      });
      // console.log(this.bannnerdata);
      this.bannnerdata = newbannerdata;
      // console.log(this.bannnerdata);
    },
    // 考生进入过滤菜单
    toExamPC() {
      if (JSON.parse(localStorage.getItem("userlist")).userType == "student") {
        let a = this.bannnerdata.filter((item) => {
          return item.parentname == "个人中心";
        });
        a[0].children = a[0].children.filter((zitem) => {
          return (
            zitem.titlename !== "独立密码" && zitem.titlename !== "开通科目"
          );
        });
        this.bannnerdata = a;
      }
    },
  },
  created() {
    this.userName = JSON.parse(localStorage.getItem("userlist")).userName;
    const hid = JSON.parse(loginvuex.state.userlist).hid
    if (this.userName === "13877286037") {
      //  2024/7/19 为了给销售演示，将临床技能考核隐藏
       this.bannnerdata = this.bannnerdata.filter((item) => {
         return item.parentname !== "临床技能考核";
       });
    }
    // 医院级隐藏技能考核
    const 隐藏技能考核的医院 = [
      {
        hid: 4173,
        name: "贵州省卫健委",
      }
    ]
    if(隐藏技能考核的医院.some(item => item.hid.toString() == hid?.toString())){
      this.bannnerdata = this.bannnerdata.filter((item) => {
        return item.parentname !== "临床技能考核";
      });
    }
     if(hid != '4035'){
    //  console.log(hid,'???');
      this.bannnerdata = this.bannnerdata.filter(item=>{
        return item.parentname !='培训任务'
      })
     }
    //获取埋点列表
    this.getmaidian();
    // this.getRouterNav(); //权限fdsasdsxsswwffdasdaw  权限需重构，暂时注释方法3.24
    this.Menuquanx();
    this.toExamPC();
  },
};
</script>

<style lang="scss" scoped>
.app-aside {
  //height: 100%;
  width: 230px;
  margin-top: 20px;
  height: calc(100vh - 100px);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #0a2d50;

  .el-menu {
    border-right: 0 none;
  }
}

.el-menu-vertical-demo {
  color: aliceblue;
  background: #0a2d50;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 10px;

  ::v-deep .el-submenu__title {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: aliceblue;
    background: #0a2d50;
    height: 64px;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #eeeeee;
      margin-left: 20px;
    }

    &:hover {
      .online-img {
        background-image: url(../../../assets/sidebar-icon/icon11.png) !important;
      }

      .online-img2 {
        background-image: url(../../../assets/sidebar-icon/icon22.png) !important;
      }

      .online-img3 {
        background-image: url(../../../assets/sidebar-icon/icon33.png) !important;
      }

      .online-img4 {
        background-image: url(../../../assets/sidebar-icon/icon44.png) !important;
      }

      .online-img5 {
        background-image: url(../../../assets/sidebar-icon/icon55.png) !important;
      }

      .online-img6 {
        background-image: url(../../../assets/sidebar-icon/px1.png) !important;
      }

      .online-img7 {
        background-image: url(../../../assets/sidebar-icon/icon66.png) !important;
      }

      .online-img8 {
        background-image: url(../../../assets/sidebar-icon/icon77.png) !important;
      }

      .online-img9 {
        background-image: url(../../../assets/sidebar-icon/icon88.png) !important;
      }

      .online-img10 {
        background-image: url(../../../assets/sidebar-icon/icon99.png) !important;
      }

      .online-img11 {
        background-image: url(../../../assets/sidebar-icon/icon1010.png) !important;
      }

      .online-img12 {
        background-image: url("../../../assets/sidebar-icon/icon101101.png") !important;
      }

      .online-img13 {
        background-image: url("../../../assets/sidebar-icon/icon101101.png") !important;
      }

      .online-img14 {
        background-image: url("../../../assets/sidebar-icon/icon_cc.png") !important;
      }
    }
  }

  ::v-deep .el-menu {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: aliceblue;
    background: #0a2d50;
  }

  ::v-deep .el-menu-item {
    color: aliceblue;
    text-align: left;
    padding-left: 80px !important;
    //  border-right: 10px solid #0a2d50 !important;
    height: 64px;
    line-height: 64px;

    &:focus {
      background-color: rgba($color: #1890ff, $alpha: 0.3);
      border-right: 10px solid #1890ff !important;
    }

    &:hover {
      color: #1890ff;
      background: rgba($color: #1890ff, $alpha: 0.3);
      box-sizing: border-box;
      border-right: 10px solid #1890ff !important;
    }
  }

  //     ::v-deep .li.el-menu-item.is-active {
  //                   ::before{
  //             content: "";
  //             display: block;
  //           width: 10px;
  //           height: 64px;
  //           background: #1890FF;
  //         }
  // }
}

.online-img {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon1.png);
}

.online-img2 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon2.png);
}

.online-img3 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon3.png);
}

.online-img4 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon4.png);
}

.online-img5 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon5.png);
}

.online-img6 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/px.png);
}

.online-img7 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon6.png);
}

.online-img8 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon7.png);
}

.online-img9 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon8.png);
}

.online-img10 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon9.png);
}

.online-img11 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url(../../../assets/sidebar-icon/icon10.png);
}

.online-img12 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url("../../../assets/sidebar-icon/icon101.png");
}

.online-img13 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url("../../../assets/sidebar-icon/icon101.png");
}

.online-img14 {
  width: 24px;
  height: 24px;
  background-size: 100%;
  display: inline-block;
  background-image: url("../../../assets/sidebar-icon/icon_c.png");
}

::v-deep .is-opened {
  .el-submenu__title {
    .online-img {
      background-image: url(../../../assets/sidebar-icon/icon11.png) !important;
    }

    .online-img2 {
      background-image: url(../../../assets/sidebar-icon/icon22.png) !important;
    }

    .online-img3 {
      background-image: url(../../../assets/sidebar-icon/icon33.png) !important;
    }

    .online-img4 {
      background-image: url(../../../assets/sidebar-icon/icon44.png) !important;
    }

    .online-img5 {
      background-image: url(../../../assets/sidebar-icon/icon55.png) !important;
    }

    .online-img6 {
      background-image: url(../../../assets/sidebar-icon/px1.png) !important;
    }

    .online-img7 {
      background-image: url(../../../assets/sidebar-icon/icon66.png) !important;
    }

    .online-img8 {
      background-image: url(../../../assets/sidebar-icon/icon77.png) !important;
    }

    .online-img9 {
      background-image: url(../../../assets/sidebar-icon/icon88.png) !important;
    }

    .online-img10 {
      background-image: url(../../../assets/sidebar-icon/icon99.png) !important;
    }

    .online-img11 {
      background-image: url(../../../assets/sidebar-icon/icon1010.png) !important;
    }

    .online-img12 {
      background-image: url(../../../assets/sidebar-icon/icon101101.png) !important;
    }

    .online-img13 {
      background-image: url(../../../assets/sidebar-icon/icon101101.png) !important;
    }

    .online-img14 {
      background-image: url(../../../assets/sidebar-icon/icon_cc.png) !important;
    }
  }
}

.isrouternav {
  color: #1890ff;
  background: rgba($color: #1890ff, $alpha: 0.3);
  box-sizing: border-box;
  border-right: 10px solid #1890ff !important;
}
</style>
